<div *ngIf="isEditable()" class="data-type-dropdown" [formGroup]="data_type">
    <div class="form-group">
        <cxone-singleselect-dropdown [ngClass]="{'data-type-dropdown-display-top': showOptionsOnTop}"
            class="setAttributes" id="datatype-dropdown" [(ngModel)]="selectedType" [options]="fieldTypeValues"
            sortOrder='' placeholder={{dropDownPlaceholder}} (ngModelChange)="onChange($event)"
            [template]="dropdownTemplate" formControlName="selectedType" (dropdownOpened)="dropdownOpened()" (click)="adjustDropdownPosition($event)"
            [search]="false" [showFooter]="false" [isRequired]="true">
        </cxone-singleselect-dropdown>
        <div *ngIf="data_type.controls['selectedType'].errors
        && (data_type.dirty || data_type.touched)">
            <span class="error-color" *ngIf="data_type.controls['selectedType'].errors['required']"
                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Required_Field">This field is
                required</span>
        </div>
    </div>
</div>

<div *ngIf="!isEditable()" class="field-type-row-text">
    <span>{{selectedType?.name}}</span>
</div>
<ng-template #dropdownTemplate let-item let-query="query">
    <div>
        <button class="no-style-button-dropdown" [innerText]="item.name"></button>
    </div>
</ng-template>